import type { PathPoint } from "../pathGeometry";

/** Sin wave along segment A→B (display only; logical endpoints stay in `points`). */
export function generateWavyPoints(
  a: PathPoint,
  b: PathPoint,
  strokeWidth: number,
  stepPx = 4
): PathPoint[] {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  const len = Math.hypot(dx, dy);
  if (len < 1) return [a, b];

  const amplitude = strokeWidth * 0.6;
  const wavelength = Math.max(strokeWidth * 4, 8);
  const ux = dx / len;
  const uy = dy / len;
  const px = -uy;
  const py = ux;

  const steps = Math.max(2, Math.ceil(len / stepPx));
  const out: PathPoint[] = [];
  for (let i = 0; i <= steps; i++) {
    const t = i / steps;
    const along = t * len;
    const wave = amplitude * Math.sin((along / wavelength) * Math.PI * 2);
    out.push([
      Math.round(a[0] + ux * along + px * wave),
      Math.round(a[1] + uy * along + py * wave),
    ]);
  }
  return out;
}
